import styled from "styled-components";

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;

  .seat-content {
      display: flex;
      justify-content: center;
      overflow-x: scroll;
  }

  .container {
      margin: 50px 0;
  }
`;

export const Content = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
`;

export const Row = styled.div`
  background: rgba(239, 239, 239, 0.8);
  -webkit-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  -moz-box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  box-shadow: 0 0 10px -3px rgb(0, 0, 0);
  border-radius: 1.5%;
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const Align = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: center;
    position: relative;
    align-items: center;
`;
